export const VIDEO_MAKER_FEATURE = '05';
export const MAXIMUM_EMAIL_LEGACY = '00';
export const MAXIMUM_EMAIL = '_0';